import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { UserInterface } from '@berriesflow/types/src/ressources/userInterface';
import { useSetAtom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import Parse from 'parse';
import Swal from 'sweetalert2';

import { _authProfile } from './_authProfile';

export interface LoginInterface {
  email: string;
  password: string;
}

export default function useAuth() {
  const { formatMessage } = useIntl();
  const setProfile = useSetAtom(_authProfile);

  const loadProfile = useAtomCallback(
    useCallback((get, set) => {
      const localProfile = Parse.User.current();
      if (!!localProfile) {
        Parse.User.current()
          ?.fetchWithInclude('entreprise')
          .then(
            (user) => {
              set(_authProfile, user);
            },
            (error) => {
              set(_authProfile, localProfile);
              console.log(error);
            },
          );
      } else {
        set(_authProfile, undefined);
      }
    }, []),
  );

  const logIn = useCallback(
    (data: LoginInterface) => {
      Parse.User.logIn<Parse.User<UserInterface>>(
        data.email,
        data.password,
      ).then(
        (user) => {
          if (user.has('berriesflow')) {
            if (user.has('entreprise')) {
              if (
                ['Administrator', 'Moderator', 'User'].includes(
                  user?.get('berriesflow')?.role || '',
                )
              ) {
                user.fetchWithInclude('entreprise').then(
                  (res) => setProfile(res),
                  (err) => console.log(err),
                );
              } else {
                Parse.User.logOut().then(null);
              }
            } else if (user.has('cooperative')) {
              window.location = 'https://coop.berriesflow.fr' as any;
            } else if (user.has('club')) {
              window.location = 'https://club.berriesflow.fr' as any;
            }
          } else {
            Parse.User.logOut().then(null);
          }
        },
        () => {
          Swal.fire({
            title: formatMessage({ id: 'login_error' }),
            icon: 'error',
          });
        },
      );
    },
    [formatMessage, setProfile],
  );

  const logOut = useCallback(() => {
    Parse.User.logOut().then(null);
    setProfile(undefined);
    window.location = (window.location.protocol +
      '//' +
      window.location.host) as any;
  }, [setProfile]);

  return { logIn, logOut, loadProfile };
}
